<script lang="ts" setup>
type Props = {
  location?: {
    city: string;
    country: string;
    latitude: number;
    longitude: number;
  };
  email?: string;
  version?: string;
};

const props = defineProps<Props>();

const mapsUrl = props.location
  ? `https://maps.google.com/?q=${props.location.latitude},${props.location.longitude}`
  : undefined;
</script>

<template>
  <footer
    class="lg:grid grid-cols-12 lg:container mx-auto pb-12 px-4 lg:px-0 pt-16 lg:pt-20 bg-primary-100 dark:bg-primary-900"
  >
    <div
      class="col-span-11 col-start-2 col-end-12 flex flex-col lg:flex-row justify-between items-start"
    >
      <UiTextBlock
        v-if="props.location?.city"
        class="text-lg divider-t-xs flex flex-col gap-y-2 lg:w-1/2"
        top-line-align="left"
      >
        <span v-if="mapsUrl">
          Currently located in
          <UiAnchor :href="mapsUrl" target="_blank" rel="noopener noreferrer">
            {{ props.location.city }}, {{ props.location.country }}
          </UiAnchor>
        </span>
        <UiAnchor
          v-if="props.email"
          :href="`mailto:${props.email}?subject=Hola Diego, te contacto desde diegomarmol.com`"
          class="font-bold"
          >{{ props.email }}</UiAnchor
        >
      </UiTextBlock>
      <UiTextBlock class="flex flex-col gap-y-2 lg:items-end lg:w-1/2">
        <UiParagraph class="text-sm">
          &copy; {{ new Date().getFullYear() }} Diego Martín Marmol. All rights
          reserved.
        </UiParagraph>
        <ClientOnly>
          <div v-if="props.version">
            <span class="text-sm text-primary-600/75 dark:text-primary-100/80"
              >v{{ props.version }}</span
            >
          </div>
        </ClientOnly>
      </UiTextBlock>
    </div>
  </footer>
</template>
